import React, { useContext, useEffect, useState } from "react";
import { SvgImages, PngImages } from "../../Utils/LocalImages";
import { Link, useLocation } from "react-router-dom";
import Image from "../../Components/Reusable/Image";
import RoutesPath from "../../Utils/RoutesPath";
import CustomTextFieldTwo from "../../Components/Reusable/CustomTextFieldTwo";
import Profilemodal from "../../Components/Modal/Profilemodal";
import { AuthContext } from "../../Context/authContext";
import ApiConstants from "../../Utils/ApiConstant";
import { useSidebar } from "../../Context/toggleContext";
import Modal from "react-bootstrap/Modal";
const Sidebar = () => {
  const [activeAccordion, setActiveAccordion] = useState(-1);
  const [currentPath, setCurrentPath] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const { user } = useContext(AuthContext);
  const { sidebarOpen, toggleSidebar } = useSidebar();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getprofilepic = async (file) => { };
  useEffect(() => {
    getprofilepic();
  }, []);

  const handleProfileClick = () => {
    setShowModal(true);
  };

  const location = useLocation();
  const isTestRoute = location.pathname.match(
    new RegExp(`^${RoutesPath.mocktest}/[a-f0-9]{24}/[a-f0-9]{24}$`)
  );
  const isBharatSatExam = location.pathname.match(
    new RegExp(`^${RoutesPath.bharatSatTest}/[a-f0-9]{24}`)
  );

  useEffect(() => {
    const pathname = location.pathname;
    if (
      pathname.startsWith(RoutesPath.studymaterials) ||
      pathname.startsWith(RoutesPath.studymodules) ||
      pathname.startsWith(RoutesPath.studytopics)
    ) {
      setActiveAccordion(2);
    } else if (
      pathname.startsWith(RoutesPath.packages) ||
      pathname.startsWith(RoutesPath.addtocart) ||
      pathname.startsWith(RoutesPath.checkout)
    ) {
      setActiveAccordion(1);
    } else if (
      pathname.startsWith(RoutesPath.mymocktest) ||
      pathname.startsWith(RoutesPath.mocktest) ||
      pathname.startsWith(RoutesPath.showresult) ||
      pathname.startsWith(RoutesPath.viewresult)
    ) {
      setActiveAccordion(3);
    } else if (pathname.startsWith(RoutesPath.paidsyllabus)) {
      setActiveAccordion(4);
    } else if (pathname.startsWith(RoutesPath.orderhistory)) {
      setActiveAccordion(5);
    } else if (pathname.startsWith(RoutesPath.changepassword)) {
      setActiveAccordion(6);
    } else if (pathname.startsWith(RoutesPath.studentprofile)) {
      setActiveAccordion(7);
    } else if (pathname.startsWith(RoutesPath.bharatsat)) {
      setActiveAccordion(8);
    } else {
      setActiveAccordion(1);
    }
  }, [location.pathname]);
  const handleLinkClick = () => {
    toggleSidebar(); // Close the sidebar when a link is clicked
  };
  return (
    <div className={`sidebar-overlay ${sidebarOpen ? "active" : ""}`}>
      <div className="sidebar d-flex flex-column overflow-auto ">
        <button className="navbar-togglercross" onClick={toggleSidebar}>
          &times;
        </button>

        <div className="stdlogo  mt-3 mb-5">
          <Link to={RoutesPath.dashboardstudent}>
            <Image
              src={PngImages.dashboardLogo}
              className="img-fluid object-fit-contain"
              alt="Logo"
              style={{ height: "60px" }}
            />
          </Link>
        </div>

        {/* Mocktest Exam SideBar */}
        {(isTestRoute || isBharatSatExam) ? (
          <>
            <div className="mx-3 mb-4 mt-2 student-profile-section">
              <div className=" d-flex justify-content-center select_profile_img mb-2">
                {/* <CustomTextFieldTwo id="file" type="file" className="d-none" /> */}
                <Image
                  className="studentmodal_profile"
                  style={{ objectFit: "cover" }}
                  src={
                    user?.profilePicture && user.profilePicture?.trim() !== ""
                      ? ApiConstants.FILE_FETCH_URL + user.profilePicture
                      : SvgImages.user_profile
                  }
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = SvgImages.user_profile;
                  }}
                />
              </div>
              <div className="profile_text mb-3 text-center mx-2 my-4">
                {/* <h2>{user?.name?.trim()}</h2> */}
                <div className="white medium-text fw-500 d-flex justify-content-start m-2">
                  <span>Name&nbsp;:</span>
                  <h2 className=" white medium-text fw-500">
                    &nbsp;
                    {user?.firstName?.trim() +
                      " " +
                      user?.middleName?.trim() +
                      " " +
                      user?.lastName?.trim()}
                  </h2>
                </div>
                <div className="white medium-text fw-500 d-flex justify-content-start m-2">
                  <span>Medium&nbsp;:</span>
                  <h2 className=" white medium-text fw-500">
                    &nbsp;{user?.medium}
                  </h2>
                </div>
                <div className="white medium-text fw-500 d-flex justify-content-start m-2">
                  <span>Class&nbsp;:</span>
                  <h3 className="white medium-text fw-500">
                    &nbsp;
                    {` ${user?.class_name?.trim()} ${user.medium ? `(${user.medium})` : ''}`}
                  </h3>
                </div>
                {
                  isBharatSatExam && (
                    <div className="white medium-text fw-500 d-flex  justify-content-start m-2 me-0">
                      <span>E-Hall Ticket No.&nbsp;:</span>
                      <h2 className=" white medium-text fw-500 orangeAccentColor">
                        &nbsp;{user?.hallTicketNumber}
                      </h2>
                    </div>
                  )
                }
                {/* <div className="white medium-text fw-500 d-flex  justify-content-start m-2">
                  <span>E-Hall Ticket No.&nbsp;:</span>
                  <h2 className=" white medium-text fw-500 orangeAccentColor">
                    &nbsp;ABC1234R
                  </h2>
                </div> */}
              </div>
            </div>
            <div className="d-flex justify-content-center text-center">
              <h2
                className=" white medium-text fw-600 orangeAccentColor cursor-pointer"
                onClick={handleShow}
              >
                View Instructions
              </h2>
            </div>
          </>
        ) : (
          <div className="mx-3 mb-4 mt-2 student-profile-section">
            <div className=" d-flex justify-content-center select_profile_img">
              {/* <CustomTextFieldTwo id="file" type="file" className="d-none" /> */}
              <Image
                className="studentmodal_profile"
                style={{ objectFit: "cover" }}
                src={
                  user?.profilePicture && user.profilePicture?.trim() !== ""
                    ? ApiConstants.FILE_FETCH_URL + user.profilePicture
                    : SvgImages.user_profile
                }
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = SvgImages.user_profile;
                }}
              />

              <div className="position-relative" onClick={handleProfileClick}>
                <a className="secondary fs-16 fw-500 studentedit_img d-flex justify-content-center align-items-center cursor-pointer">
                  <Image src={SvgImages.profile_editng} />
                </a>

                {/* <input type="file" className="edit_img opacity-0" multiple={false} accept="image/*" name="fileupload"
                onChange={(e) => {
                  if (e.target.files.length > 0) {
                    updateProfilePic(e.target.files[0]);
                  }
                }} /> */}
              </div>
              <Profilemodal
                showModal={showModal}
                setShowModal={setShowModal}
                title={"Update Profile Picture"}
                titletwo={"Delete Photo"}
                submitButtonText={"Update Photo"}
                className="Updatebtnmodal"
              ></Profilemodal>
            </div>
            <div className="profile_text mb-3 text-center">
              {/* <h2>{user?.name?.trim()}</h2> */}
              <h2 className=" white medium-text fw-600">
                {user?.firstName?.trim() +
                  " " +
                  user?.middleName?.trim() +
                  " " +
                  user?.lastName?.trim()}
              </h2>
              <h3 className="white small-text fw-400">
                {`Class ${user?.class_name?.trim()} ${user.medium ? `(${user.medium})` : ''}`}
              </h3>
            </div>
          </div>
        )}

        {isTestRoute || isBharatSatExam ? null : (
          <>
            <div className="d-flex flex-column ps-4 mb-1">
              <Link to={RoutesPath.dashboardstudent} onClick={handleLinkClick}>
                <div
                  className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 1
                    ? "accordianHeaderActive"
                    : "accordianHeaderInactive"
                    }`}
                  onClick={() => {
                    setActiveAccordion(1);
                  }}
                >
                  {" "}
                  <div className="d-flex gap-3">
                    <Image src={SvgImages.packages} />
                    <h1
                      className="white small-medium-text fw-500 mb-0"
                      style={{ marginTop: 1 }}
                    >
                      Purchase Packages
                    </h1>
                  </div>
                </div>
              </Link>
            </div>

            {/* <div className="d-flex flex-column ps-4 mb-1">
              <Link to={RoutesPath.studymaterials} onClick={handleLinkClick}>
                <div
                  className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${
                    activeAccordion == 2
                      ? "accordianHeaderActive"
                      : "accordianHeaderInactive"
                  }`}
                  onClick={() => {
                    setActiveAccordion(2);
                  }}
                >
                  {" "}
                  <div className="d-flex gap-3">
                    <Image src={SvgImages.studymaterials} />
                    <div className="d-flex gap-3 align-items-center">
                      <h1
                        className="white small-medium-text fw-500 mb-0"
                        style={{ marginTop: 1, whiteSpace: "nowrap" }}
                      >
                        Study Materials
                      </h1>
                      <div
                        className="Caption orangeAccentColor fw-600"
                        style={{ marginTop: "3px" }}
                      >
                        Basic
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div> */}

            <div className="d-flex flex-column ps-4 mb-1">
              <Link to={RoutesPath.mymocktest} onClick={handleLinkClick}>
                <div
                  className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 3
                    ? "accordianHeaderActive"
                    : "accordianHeaderInactive"
                    }`}
                  onClick={() => {
                    setActiveAccordion(3);
                  }}
                >
                  {" "}
                  <div className="d-flex gap-3">
                    <Image src={SvgImages.mocktest} />
                    <h1
                      className="white small-medium-text fw-500 mb-0"
                      style={{ marginTop: 1 }}
                    >
                      Mock Test
                    </h1>
                  </div>
                </div>
              </Link>
            </div>
            {user.paidSyllabus === true ? (
              <div className="d-flex flex-column ps-4 mb-1 ">
                <Link to={RoutesPath.paidsyllabus} onClick={handleLinkClick}>
                  <div
                    className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader shine-effect-container accordianPaid ${activeAccordion == 4
                      ? "shine-effect-active"
                      : "shine-effect-active"
                      }`}
                    onClick={() => {
                      setActiveAccordion(4);
                    }}
                  >
                    {" "}
                    <div className="d-flex gap-3">
                      <Image src={SvgImages.crownimg} />
                      <h1
                        className="white small-medium-text fw-500 mb-0"
                        style={{ marginTop: 1 }}
                      >
                        Pradnya Learnitics
                      </h1>
                    </div>
                  </div>
                </Link>
              </div>
            ) : null}

            {user?.shouldShowBharatSATTab == true && <div className="d-flex flex-column ps-4 mb-1">
              <Link to={RoutesPath.bharatsat} onClick={handleLinkClick}>
                <div
                  className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 8
                    ? "accordianHeaderActive"
                    : "accordianHeaderInactive"
                    }`}
                  onClick={() => {
                    setActiveAccordion(8);
                  }}
                >
                  {" "}
                  <div className="d-flex gap-3">
                    <Image src={SvgImages.bharatset} />
                    <h1
                      className="white small-medium-text fw-500 mb-0"
                      style={{ marginTop: 1 }}
                    >
                      Bharat SAT
                    </h1>
                  </div>
                </div>
              </Link>
            </div>}

            <div className="d-flex flex-column ps-4 mb-1">
              <Link to={RoutesPath.orderhistory} onClick={handleLinkClick}>
                <div
                  className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 5
                    ? "accordianHeaderActive"
                    : "accordianHeaderInactive"
                    }`}
                  onClick={() => {
                    setActiveAccordion(5);
                  }}
                >
                  {" "}
                  <div className="d-flex gap-3">
                    <Image src={SvgImages.orderhistory} />
                    <h1
                      className="white small-medium-text fw-500 mb-0"
                      style={{ marginTop: 1 }}
                    >
                      Order History
                    </h1>
                  </div>
                </div>
              </Link>
            </div>

            <div className="d-flex flex-column ps-4 mb-1">
              <Link to={RoutesPath.changepassword} onClick={handleLinkClick}>
                <div
                  className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 6
                    ? "accordianHeaderActive"
                    : "accordianHeaderInactive"
                    }`}
                  onClick={() => {
                    setActiveAccordion(6);
                  }}
                >
                  {" "}
                  <div className="d-flex gap-3">
                    <Image src={SvgImages.changepassword} />
                    <h1
                      className="white small-medium-text fw-500 mb-0"
                      style={{ marginTop: 1 }}
                    >
                      Change Password
                    </h1>
                  </div>
                </div>
              </Link>
            </div>
            <div className="d-flex flex-column ps-4 mb-1">
              <Link to={RoutesPath.studentprofile} onClick={handleLinkClick}>
                <div
                  className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 7
                    ? "accordianHeaderActive"
                    : "accordianHeaderInactive"
                    }`}
                  onClick={() => {
                    setActiveAccordion(7);
                  }}
                >
                  {" "}
                  <div className="d-flex gap-3">
                    <Image src={SvgImages.profile} />
                    <h1
                      className="white small-medium-text fw-500 mb-0"
                      style={{ marginTop: 1 }}
                    >
                      Profile
                    </h1>
                  </div>
                </div>
              </Link>
            </div>
          </>
        )}
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        contentClassName="rounded-5"
      >
        <div
          className="modal-header px-5 my-2 medium-text fs-5 fw-600 justify-content-end d-flex"
          style={{ borderBottom: "none" }}
        >
          <Image
            className="cursor-pointer"
            src={PngImages.redcross}
            style={{ aspectRatio: 1 }}
            onClick={handleClose}
          />
        </div>

        <div className="border mx-5 mb-5 ">
          <div
            className="d-flex justify-content-between mb-3 align-items-center px-3 py-2"
            id="contained-modal-title-vcenter"
            style={{ backgroundColor: "#EFF5FF" }}
          >
            <h2 className="Heading headingColor text-center fw-600">
              Instructions:
            </h2>
            <div className="medium-text fw-500 text-danger">
              Please read the instructions carefully before starting the test.
            </div>
          </div>

          <Modal.Body className="">
            <div className="container-fluid ps-4">
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 1. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Camera Visibility: Ensure your camera is on and you are
                    clearly visible from head to chest throughout the
                    examination.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 2. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Fair Play: Maintain academic integrity. Do not engage in any
                    form of cheating or malpractice.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 3. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    No Communication: Refrain from communicating with anyone
                    during the examination.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 4. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    No External Assistance: Do not seek help from any external
                    source, including textbooks, notes, or online resources.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 5. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Time Management: The examination duration is 90 minutes.
                    Allocate time wisely to answer all questions.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 6. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Question Format: The examination consists of 100 Multiple
                    Choice Questions (MCQs).
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 7. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Marking Scheme: Each correct answer carries 2 marks.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 8. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Submission Deadline: The examination will be automatically
                    submitted after 90 minutes. Ensure you submit your answers
                    before the deadline.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 9. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Result Implications: Any violation of the examination rules
                    may lead to the cancellation of your result.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 10. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    The merit list will be prepared based on the marks obtained
                    by the student and the time they took to complete the test.
                  </em>
                </div>
              </div>
              <div className="mb-4">
                <div className="mb-2 medium-text fw-600 d-flex">
                  <span> 11. &nbsp;</span>
                  <em className="medium-text fw-400 ">
                    Each incorrect answer will result in a deduction of 0.5
                    marks from your total score. Please be mindful of this when
                    answering the questions.
                  </em>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
};

export default Sidebar;
